import React, {Component} from 'react';
import MDSpinner from "react-md-spinner";
import jquery from 'jquery';

import {RepoBuildDisplay} from './RepoBuildDisplay.js';

export class BranchDetails extends Component {

  componentDidMount() {
    this.queryRepoId();
  }

  selectBranch(data) {
    /* Wish there would be Smalltalk's >>#select:... */
    const res = data.filter(entry =>
                    entry.branch === this.props.branch &&
                    entry.ci_system === this.props.ci_system &&
                    entry.sub_number === this.props.sub_number);

    const branch = res.length > 0 ? res[0] : null;
    const buildId = this.props.build_id == null ? branch.last_id : this.props.build_id;
    this.setState({branch: res[0], build_id: buildId});
  }

  /* query the branches and find our subumber and name... */
  findBranch() {
    var url = 'https://api.bob-bench.org/v1/search/branches/' + this.state.repo_id;
    jquery.getJSON(url)
      .done(function(data) {
        this.selectBranch(data);
      }.bind(this));
  }

  /* Resolve the repo name to a repo id */
  queryRepoId() {
    var url = 'https://api.bob-bench.org/v1/search/repositories?'
                + jquery.param({'url': 'https://github.com/' + this.props.project});
    jquery.getJSON(url)
      .done(function(data) {
        this.setState({repo_id: data[0].id});
        this.findBranch();
      }.bind(this))
      .fail(function(error, a, b) {
      });
  }

  render() {
    if (this.state == null || this.state.branch == null) {
      return (
        <div>
          <p>Loading branch information<MDSpinner/></p>
        </div>);
    }

    return (
      <div>
        <RepoBuildDisplay buildId={this.state.build_id} ci_system={this.props.ci_system} sub_number={this.props.sub_number}/>
      </div>)
    }
}



// WEBPACK FOOTER //
// ./src/views/BranchDetails.js